module.exports = __webpack_public_path__ + "assets/img/00156.c275b7bd.png";